import { POWERUPS, POWERUP_WEIGHTS } from "./constants";

export function pickWeightedPowerup() {
  const entries = POWERUPS.map((k) => [k, POWERUP_WEIGHTS[k]]);
  const total = entries.reduce((s, [, w]) => s + w, 0);
  let r = Math.random() * total;
  for (const [k, w] of entries) {
    if (r < w) return k;
    r -= w;
  }
  return entries[0][0];
}
